/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: Log.ts
 * Created by: Kevin
 * Create Date: 2022-12-09 18:19
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

export default class Log {

    // verbose levels (log/debug/info/trace) are compiled out of production
    // builds; warn/error always pass through
    private static readonly S_Verbose = process.env.NODE_ENV !== 'production';

    private constructor() {
    }

    public static log(message?: any, ...optionalParams: any[]) {
        if (Log.S_Verbose) console.log(message, ...optionalParams)
    }

    public static debug(message?: any, ...optionalParams: any[]) {
        if (Log.S_Verbose) console.debug(message, ...optionalParams)
    }

    public static info(message?: any, ...optionalParams: any[]) {
        if (Log.S_Verbose) console.info(message, ...optionalParams)
    }

    public static warn(message?: any, ...optionalParams: any[]) {
        console.warn(message, ...optionalParams)
    }

    public static error(message?: any, ...optionalParams: any[]) {
        console.error(message, ...optionalParams)
    }

    public static trace(message?: any, ...optionalParams: any[]) {
        if (Log.S_Verbose) console.trace(message, ...optionalParams)
    }
}